import React from 'react'
import { Checkbox as CB, Form, Grid } from 'semantic-ui-react'
import Checkbox from '@cbgms/components/form/Checkbox'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { change, formValueSelector, isDirty } from 'redux-form'

const ShopModules: React.FC<{ form: string }> = ({ form }) => {
  const { t } = useTranslation()
  const formIsDirty = useSelector(state => isDirty(form)(state))

  const moduleSwitchDefaultOrderAccount: boolean | undefined = useSelector((state: IRootReducerState) =>
    formValueSelector(form)(state, 'Shop.ModuleSwitchDefaultOrderAccount')
  )
  const moduleAddOrderAccount: boolean | undefined = useSelector((state: IRootReducerState) =>
    formValueSelector(form)(state, 'Shop.ModuleAddOrderAccount')
  )
  const moduleGMS: boolean | undefined = useSelector((state: IRootReducerState) => formValueSelector(form)(state, 'Shop.ModuleGMSEnabled'))
  const modulePortal: boolean | undefined = useSelector((state: IRootReducerState) =>
    formValueSelector(form)(state, 'Shop.ModulePortalEnabled')
  )

  const moduleFleetLease: boolean | undefined = useSelector((state: IRootReducerState) =>
    formValueSelector(form)(state, 'Shop.ModuleFleetLeaseEnabled')
  )

  const moduleFleetLeaseWhiteLabel: boolean | undefined = useSelector((state: IRootReducerState) =>
    formValueSelector(form)(state, 'Shop.ModuleFleetLeaseWhiteLabelEnabled')
  )

  const dispatch = useDispatch()

  React.useEffect(() => {
    if (moduleGMS) {
      dispatch(change(form, 'Shop.ModulePortalEnabled', false))
      dispatch(change(form, 'Shop.ModuleSwitchDefaultOrderAccount', true))
      dispatch(change(form, 'Shop.ModuleAddOrderAccount', true))
      dispatch(change(form, 'Shop.ModuleFleetLeaseWhiteLabelEnabled', false))
    }
  }, [moduleGMS])

  React.useEffect(() => {
    if (modulePortal) {
      dispatch(change(form, 'Shop.ModuleGMSEnabled', false))
      dispatch(change(form, 'Shop.ModuleFleetLeaseWhiteLabelEnabled', false))
    }
  }, [modulePortal])

  React.useEffect(() => {
    if (!moduleSwitchDefaultOrderAccount && moduleAddOrderAccount) {
      dispatch(change(form, 'Shop.ModuleAddOrderAccount', false))
    }
  }, [moduleSwitchDefaultOrderAccount])

  React.useEffect(() => {
    if (moduleAddOrderAccount) {
      dispatch(change(form, 'Shop.ModuleSwitchDefaultOrderAccount', true))
    }
  }, [moduleAddOrderAccount])

  React.useEffect(() => {
    if (moduleFleetLease && formIsDirty) {
      dispatch(change(form, 'Shop.ModuleCourtesyVehiclesEnabled', true))
      dispatch(change(form, 'Shop.ModuleTyreChangeEnabled', true))
    }
  }, [moduleFleetLease])

  React.useEffect(() => {
    if (moduleFleetLeaseWhiteLabel) {
      dispatch(change(form, 'Shop.ModuleFleetLeaseEnabled', true))
    }
  }, [moduleFleetLeaseWhiteLabel])

  return (
    <div>
      <Form.Group grouped>
        <Grid>
          <Grid.Row>
            <Grid.Column width='6'>
              <label>{t('shop.activated_modules')}</label>
              <br />
              <CB toggle label={t('shop.module_zero')} checked />
              <Checkbox
                toggle
                label={t('shop.module_portal')}
                name='Shop.ModulePortalEnabled'
                value='ModulePortalEnabled'
                disabled={moduleFleetLeaseWhiteLabel}
              />
              <Checkbox
                toggle
                label={t('shop.module_gms')}
                name='Shop.ModuleGMSEnabled'
                value='ModuleGMSEnabled'
                disabled={moduleFleetLeaseWhiteLabel}
              />
              <Checkbox
                toggle
                label={t('shop.module_fleet_lease_white_label')}
                name='Shop.ModuleFleetLeaseWhiteLabelEnabled'
                value='ModuleFleetLeaseWhiteLabelEnabled'
                disabled={moduleGMS || modulePortal}
              />
            </Grid.Column>
            <Grid.Column width='6'>
              <label>{t('shop.additional_modules')}</label>
              <br />
              <Checkbox
                toggle
                data-testid='ModuleAddOrderAccount'
                label={t('shop.module_add_order_account')}
                name='Shop.ModuleAddOrderAccount'
                value='ModuleAddOrderAccount'
                disabled={moduleGMS}
              />
              <Checkbox
                toggle
                data-testid='ModuleSwitchDefaultOrderAccount'
                label={t('shop.module_switch_default_order_account')}
                name='Shop.ModuleSwitchDefaultOrderAccount'
                value='ModuleSwitchDefaultOrderAccount'
                disabled={moduleGMS}
              />
              <Checkbox
                toggle
                label={t('shop.module_fleet_lease')}
                name='Shop.ModuleFleetLeaseEnabled'
                value='ModuleFleetLeaseEnabled'
                disabled={moduleFleetLeaseWhiteLabel}
              />
              <Checkbox
                toggle
                label={t('shop.module_timeregistration')}
                name='Shop.ModuleTimeRegistrationEnabled'
                value='ModuleTimeRegistration'
              />
              <Checkbox
                toggle
                label={t('shop.module_vehicle_sales')}
                name='Shop.ModuleVehicleSalesEnabled'
                value='ModuleVehicleSalesEnabled'
              />
              <Checkbox toggle label={t('shop.module_tyre_change')} name='Shop.ModuleTyreChangeEnabled' value='ModuleTyreChangeEnabled' />
              <Checkbox
                toggle
                label={t('shop.module_courtesy_vehicles')}
                name='Shop.ModuleCourtesyVehiclesEnabled'
                value='ModuleCourtesyVehiclesEnabled'
              />
              <Checkbox
                toggle
                label={t('shop.module_rental_vehicles')}
                name='Shop.ModuleRentalVehiclesEnabled'
                value='ModuleRentalVehiclesEnabled'
              />
              <Checkbox toggle label={t('shop.module_crm')} name='Shop.ModuleCRMEnabled' value='ModuleCRMEnabled' />
              <Checkbox
                toggle
                label={t('shop.module_internal_invoicing')}
                name='Shop.ModuleInternalInvoicingEnabled'
                value='ModuleInternalInvoicingEnabled'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Group>
    </div>
  )
}

export default ShopModules
